import styled from 'styled-components'

import { Action, TruncatePreset } from '../styles/mixins'
import { StyledStatusBadge } from './bootstrap/StyledStatusBadge'

export const InactiveBadge = styled(StyledStatusBadge)`
  ${Action({
    background: 'var(--badge-color-inactive) !important',
    color: 'var(--font-color-light) !important',
  })}
  ${TruncatePreset()};
`
